<template>
  <v-dialog v-model="open" content-class="fit" max-width="1280" :max-height="maxHeight">
    <v-card class="gradient fit">
      <div class="picture-index accent elevation-2">{{ currentIndex + 1 }}</div>
      <v-img :src="currentSrc" contain :max-height="maxHeight" />
      <v-btn v-if="photos.length > 1" class="btn prev accent" @click="prev">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn v-if="photos.length > 1" class="btn next accent" @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn v-if="showPushToDataset" class="push-btn accent" @click="pushToDataset">
        <v-icon>mdi-plus</v-icon>
        Push to dataset #{{ projectId }}
      </v-btn>
    </v-card>

  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash-es'
import { TSCommonMixin } from '@/mixins/TSCommonMixin'
export default {
  name: 'TSPhotoGallery',
  mixins: [TSCommonMixin],
  data() {
    return {
      currentIndex: 0,
      maxHeight: 800,
      open: false,
      photos: [],
      metadata: [],
    }
  },
  mounted() {
    this.$root.$on('toggleGallery', this.toggleGallery)
    this.computeMaxHeight()
    window.addEventListener('resize', this.computeMaxHeight, false)
    document.addEventListener('keyup', this.keyListener)
  },
  destroyed() {
    this.$root.$off('toggleGallery', this.toggleGallery)
    window.removeEventListener('resize', this.computeMaxHeight)
    document.removeEventListener('keyup', this.keyListener)
  },
  computed: {
    ...mapGetters({
      currentFlux: 'flux/currentFlux',
      currentFluxItem: 'fluxItems/currentFluxItem'
    }),
    currentSrc() {
      return this.photos && this.currentIndex < this.photos.length
        ? this.photos[this.currentIndex]
        : ''
    },
    showPushToDataset() {
      const o = get(this, 'currentFlux.settings.options')
      const dataset = get(this.metadata, `[${this.currentIndex}].dataset`)
      return this.role === 'ADMIN' && o && o.enablePushToDataset && dataset && !dataset.includes(this.projectId)
    },
    projectId() {
      return get(this, 'currentFlux.settings.options.labelStudioProjectId')
    }
  },
  methods: {
    ...mapActions({
      pushPictureToDataset: 'pictures/pushPictureToDataset',
    }),
    computeMaxHeight() {
      const h =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      this.maxHeight = h * 0.8
    },
    toggleGallery({ open, currentIndex, photos, metadata }) {
      this.currentIndex = currentIndex
      this.photos = photos
      this.open = open
      this.metadata = metadata
    },
    keyListener(evt) {
      switch (evt.keyCode) {
        case 37:
          this.prev()
          break
        case 39:
          this.next()
          break
        case 27:
          this.open = false
          break
        default:
          break
      }
    },
    next() {
      const next = this.currentIndex + 1
      this.currentIndex = next < this.photos.length ? next : 0
    },
    prev() {
      const prev = this.currentIndex - 1
      this.currentIndex = prev < 0 ? this.photos.length - 1 : prev
    },
    async pushToDataset() {
      const meta = this.metadata && this.metadata[this.currentIndex]
      const fromPictures = meta && meta.fromPictures
      if (fromPictures) {
        await this.pushPictureToDataset({
          projectId: this.projectId,
          id: meta.originalIdx,
        }).catch(() => {
           this.$root.$emit('openSnackBar', {
            message: `Une erreur est survenue lors de la tentative de push de l'image vers le dataset #${this.projectId}`,
            color: 'error',
          })
        })
        this.metadata[this.currentIndex].dataset.push(this.projectId)
        this.$root.$emit('openSnackBar', {
          message: `L'image a été poussée vers le dataset #${this.projectId}`,
          color: 'success',
        })
      } else{
         this.$root.$emit('openSnackBar', {
          message: `L'image doit provenir de la table "pictures" pour pouvoir être poussée vers un dataset`,
          color: 'error',
        })
      }
    },
  }
}
</script>
<style lang="scss">
.fit {
  width: fit-content !important;
  overflow: hidden;

  .btn {
    position: absolute;
    opacity: 0.7;
    height: 100px !important;
    top: calc(50% - 50px);

    &.next {
      right: -10px;
      border-top-left-radius: 60px;
      border-bottom-left-radius: 60px;
    }

    &.prev {
      left: -10px;
      border-top-right-radius: 60px;
      border-bottom-right-radius: 60px;
    }
  }

  .push-btn {
    position: absolute;
    min-width: 0 !important;
    bottom: 10px;
    right: 10px;
    height: 40px !important;
    width: 210px !important;
    border-radius: 12px;
    right: calc(50% - 90px);
  }
}

.picture-index {
  line-height: 40px;
  text-align: center;
  height: 40px;
  width: 40px;
  font-size: 20px;
  z-index: 10;
  position: absolute;
  color: white;
  border-top-right-radius: 0 !important;
  text-shadow: 1px 1px 1px rgba($color: #000000, $alpha: 0.5);
  opacity: 0.7;
}
</style>
